export const checkIndividualPosition = ({
  position,
  jobTitle,
  firmSize,
}: {
  position: string;
  jobTitle: string;
  firmSize: string;
}) => {
  // Needs to be the same as in signupConstants. Automatic position when firmSize is 'Individuel'.
  if (jobTitle === 'Avocat' && firmSize === 'Individuel') {
    return 'Associé';
  }
  if (jobTitle === 'Juriste' && firmSize === 'Individuel') {
    return 'Juriste d’entreprise';
  }
  if (position === 'initial') {
    return '';
  }
  return position;
};

export function linkedInTrack() {
  const element = document.createElement('img');
  const url =
    'https://dc.ads.linkedin.com/collect/?pid=497052&conversionId=607620&fmt=gif';
  element.alt = '';
  element.width = 1;
  element.width = 1;
  element.src = url;
}
